var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_23567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2553 0H1.13058C0.506293 0 0 0.506293 0 1.13058V25.3576C0 25.9818 0.506293 26.4881 1.13058 26.4881H20.0093C20.6336 26.4881 21.1399 25.9818 21.1399 25.3576V5.88458L15.2553 0Z",
    fill: "url(#paint0_linear_1819_23567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2549 4.754C15.2549 5.37829 15.7612 5.88458 16.3855 5.88458H21.1395L15.2549 0V4.754Z",
    fill: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86463 7.90769H5.29698C4.82073 7.90769 4.43457 7.52153 4.43457 7.04528C4.43457 6.56902 4.82073 6.18286 5.29698 6.18286H8.86463C9.34089 6.18286 9.72705 6.56902 9.72705 7.04528C9.72705 7.52153 9.34089 7.90769 8.86463 7.90769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2022 13.2431H5.29698C4.82073 13.2431 4.43457 12.857 4.43457 12.3807C4.43457 11.9045 4.82073 11.5183 5.29698 11.5183H14.2022C14.6784 11.5183 15.0646 11.9045 15.0646 12.3807C15.0646 12.857 14.6784 13.2431 14.2022 13.2431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2022 16.7741H5.29698C4.82073 16.7741 4.43457 16.388 4.43457 15.9117C4.43457 15.4355 4.82073 15.0493 5.29698 15.0493H14.2022C14.6784 15.0493 15.0646 15.4355 15.0646 15.9117C15.0646 16.388 14.6784 16.7741 14.2022 16.7741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2022 20.3054H5.29698C4.82073 20.3054 4.43457 19.9192 4.43457 19.443C4.43457 18.9667 4.82073 18.5806 5.29698 18.5806H14.2022C14.6784 18.5806 15.0646 18.9667 15.0646 19.443C15.0646 19.9192 14.6784 20.3054 14.2022 20.3054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0254 30.0001C26.9271 30.0001 30.0899 26.8372 30.0899 22.9356C30.0899 19.034 26.9271 15.8711 23.0254 15.8711C19.1238 15.8711 15.9609 19.034 15.9609 22.9356C15.9609 26.8372 19.1238 30.0001 23.0254 30.0001Z",
    fill: "url(#paint1_linear_1819_23567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0378 22.9357L25.7906 21.1829C26.0694 20.904 26.0694 20.4492 25.7906 20.1703C25.5117 19.8915 25.0569 19.8915 24.778 20.1703L23.0253 21.9231L21.2725 20.1703C20.9936 19.8915 20.5388 19.8915 20.2599 20.1703C19.9811 20.4492 19.9811 20.904 20.2599 21.1829L22.0127 22.9357L20.2599 24.6884C19.9811 24.9673 19.9811 25.4221 20.2599 25.701C20.3994 25.8404 20.5839 25.9112 20.7662 25.9112C20.9486 25.9112 21.1331 25.8404 21.2725 25.701L23.0253 23.9482L24.778 25.701C24.9174 25.8404 25.1019 25.9112 25.2843 25.9112C25.4666 25.9112 25.6511 25.8404 25.7906 25.701C26.0694 25.4221 26.0694 24.9673 25.7906 24.6884L24.0378 22.9357Z",
    fill: "url(#paint2_linear_1819_23567)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1819_23567",
    x1: 10.5699,
    y1: 26.486,
    x2: 10.5699,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1819_23567",
    x1: 23.0254,
    y1: 30.0001,
    x2: 23.0254,
    y2: 15.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1819_23567",
    x1: 20.0497,
    y1: 22.9357,
    x2: 26.0008,
    y2: 22.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B65FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_23567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClLogo);
export default __webpack_public_path__ + "static/media/cl-logo.0dc2794c202a8a27810e2326a690a4e5.svg";
export { ForwardRef as ReactComponent };